module.exports = __webpack_public_path__ + "media/images/social_networks/youtube-aaa561c0f8bbe082941756e50d951a26.svg";